import { render } from "./index.vue?vue&type=template&id=76794260&scoped=true&ts=true"
import script from "./script/index.ts?vue&type=script&lang=ts"
export * from "./script/index.ts?vue&type=script&lang=ts"

import "./style/index.less?vue&type=style&index=0&id=76794260&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76794260"],['__file',"src/views/manga-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76794260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76794260', __exports__)) {
    console.log('reload')
    api.reload('76794260', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=76794260&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('76794260', render)
  })

}


export default __exports__